import { escapeSpecialCharsForRegex } from '~~/common/js/universal/utils';

/**
 * Returns a function which takes a string and wraps all parts
 * not matching `match` with the given HTML tag.
 *
 * @param {string} match the string to match against
 * @param {stirng} tag the tag to wrap the non-matches with
 */
export const wrapNotMatching = (match, tag = 'strong') => {
  const escaped = escapeSpecialCharsForRegex(match);
  const regex = new RegExp(`(${escaped})`, 'ig');
  // template string intentionally left without whitespace
  // to avoid spaces rendered inside the <mark>
  return (text) => text
    .split(regex)
    // empty strings and the matched part is passed unchanged
    .map((part) => (regex.test(part) || !part ? part : `<${tag}>${part}</${tag}>`))
    .join('');
};

/**
 * Injects the provided results after any continuous results which match any of the provided types.
 * Can be used to, for instance, inject a notice after all ads and product ads.
 *
 * @param {array} results the original results array
 * @param {array} toInject the array of results to inject after the skipped types
 * @param {array} typesToSkip the result types to skip
 */
export const injectResultsAfterResultTypes = (results = [], toInject = [], typesToSkip = []) => {
  if (results.length === 0) {
    return toInject;
  }
  const firstIndexAfterSkipped = results.findIndex(({ type }) => !typesToSkip.includes(type));
  if (firstIndexAfterSkipped >= 0) {
    const updatedResults = [...results];
    updatedResults.splice(firstIndexAfterSkipped, 0, ...toInject);
    return updatedResults;
  }
  return results;
};

export const splitProductAdsForABTest = (results = [], variant = false) => {
  if (!variant) {
    return { results, productAds: [] };
  }
  return results.reduce((acc, result) => {
    if (result.type === 'productAds') {
      acc.productAds = result?.items ?? [];
    } else {
      acc.results.push(result);
    }
    return acc;
  }, { results: [], productAds: [] });
};

export const createIsResultOfType = (type) => (result) => result.type === type;

export const createIsResultOfOneOfTypes = (types) => (result) => {
  const contains = types.some((type) => type === result.type);
  return contains;
};
